goog.provide("shadow.js.shim.module$src$svg$type$thumbnails$youtube_non_skippable_svg$default");
shadow.js.shim.module$src$svg$type$thumbnails$youtube_non_skippable_svg$default = shadow.js.shim.module$src$svg$type$thumbnails$youtube_non_skippable_svg.default;
